<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('You are not authorized') }}! 🔐
        </h2>
        <p class="mb-2">
          {{ $t('You don’t have permission to access this page') }}
          .
        </p>
        <!-- <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          @click="loginRoute"
        >Back to Home</b-button> -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BImg } from 'bootstrap-vue'
// import { getHomeRouteForLoggedInUser, getUserData } from '@/auth/utils'

export default {
  components: {
    BImg,
    // BButton,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      this.$router.push({ name: 'dashboard' })
      // const user = getUserData()
      // return getHomeRouteForLoggedInUser(user ? user.role : null)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
